import { useEffect } from "react";
import useGameStore from "./store/gameStore";
import "./App.css";
import Game from "./components/Game";
import NewHighScore from "./components/NewHighScore";

function App() {
  const showHighScoreForm = useGameStore((s) => s.showHighScoreForm);
  const newHighScore = useGameStore((s) => s.newHighScore);
  const setLoadedAudio = useGameStore((s) => s.setLoadedAudio);
  const fetchLeaderboard = useGameStore((s) => s.fetchLeaderboard);

  const sfx = [
    "/c.wav",
    "/d.wav",
    "/e.wav",
    "/f.wav",
    "/g.wav",
    "/a.wav",
    "/low_c.wav",
    "/success2.wav",
  ];

  useEffect(() => {
    const audioElements = sfx.map((soundFile) => {
      const audio = new Audio(soundFile);
      audio.load();
      return audio;
    });
    setLoadedAudio(audioElements);
    fetchLeaderboard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {showHighScoreForm && newHighScore !== undefined && <NewHighScore />}
      <Game />
    </>
  );
}

export default App;
